'use client';

import { assert } from '@common/utils';
import { useQuery } from '@tanstack/react-query';

import { BOOKMARK_TYPE } from '@/api';
import { UnauthQueryOptions } from '@/api/v2';
import { BookmarkButton } from '@/components/molecule/BookmarkButton';
import { useBookmark } from '@/hooks/useBookmark';
import { hometownNewsQueryOptions } from '@/query-factory';
import { useAuthStore } from '@/stores/AuthStore';

interface HometownNewsBookmarkButtonProps {
  idIdx: string;
}

export const HometownNewsBookmarkButton = ({
  idIdx,
}: HometownNewsBookmarkButtonProps) => {
  const isLogin = useAuthStore((state) => !!state.isLogin);

  const { data: id } = useQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/hometown-news/{hometown_news_id_idx}'
    ]({
      path: {
        hometown_news_id_idx: idIdx,
      },
    }),
    select: ({ context }) => context?.detail_hometown_news?.hometown_news_id,
  });

  const feedbackQuery = useQuery({
    ...hometownNewsQueryOptions.feedback({
      id,
      isLogin,
    }),
    select: ({ context }) => ({
      isBookmarked: context?.wishlist_yn,
      bookmarkCount: context?.wishlist_count,
    }),
  });

  const { bookmark } = useBookmark();

  return (
    <BookmarkButton
      {...feedbackQuery.data}
      onClick={(isBookmarked) => {
        assert(id);

        bookmark({
          bookmarkType: BOOKMARK_TYPE.HOMETOWN_NEWS,
          contentId: id,
          isBookmarked,
          idx: idIdx,
        });
      }}
    />
  );
};
